(() => {
  const ROOT_SELECTOR = '[data-image-safe-collection]';
  let generation = 0;

  const currentVirtualPage = () => {
    const value = Number.parseInt(new URL(window.location.href).searchParams.get('page'), 10);
    return Number.isFinite(value) && value > 0 ? value : 1;
  };

  const virtualPageUrl = (page) => {
    const url = new URL(window.location.href);
    url.searchParams.delete('section_id');
    if (page <= 1) url.searchParams.delete('page');
    else url.searchParams.set('page', String(page));
    return `${url.pathname}${url.search}${url.hash}`;
  };

  const fetchUrl = (root, nativePage) => {
    const url = new URL(window.location.href);
    url.searchParams.set('page', String(nativePage));
    url.searchParams.set('section_id', root.dataset.sectionId);
    return `${url.pathname}${url.search}`;
  };

  const cardsFrom = (scope) => {
    const grid = scope.querySelector('#product-grid');
    if (!grid) return [];
    return Array.from(grid.children).filter((node) => node.matches && node.matches('card-product'));
  };

  const keyFor = (card) => card.dataset.productUrl || card.querySelector('a[href]')?.getAttribute('href') || '';

  const fetchNativePage = async (root, page) => {
    const response = await fetch(fetchUrl(root, page), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!response.ok) throw new Error(`HTTP ${response.status} loading page ${page}`);

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fetchedRoot = doc.querySelector(ROOT_SELECTOR);
    if (!fetchedRoot) throw new Error(`Collection grid not found on page ${page}`);

    return cardsFrom(fetchedRoot);
  };

  const collectUntil = async (root, requestedPage, token) => {
    const pageSize = Number.parseInt(root.dataset.pageSize, 10) || 24;
    const nativePages = Number.parseInt(root.dataset.nativePages, 10) || 1;
    const needed = requestedPage * pageSize + 1;
    const cards = [];
    const seen = new Set();
    let exhausted = false;

    for (let nativePage = 1; nativePage <= nativePages; nativePage += 1) {
      if (token !== generation) return null;

      let pageCards;
      if (nativePage === 1 && requestedPage === 1 && Number.parseInt(root.dataset.currentPage, 10) === 1) {
        pageCards = cardsFrom(root);
      } else {
        try {
          pageCards = await fetchNativePage(root, nativePage);
        } catch (error) {
          console.warn('[Daniello] image-safe pagination retry:', error);
          await new Promise((resolve) => setTimeout(resolve, 250));
          if (token !== generation) return null;
          try {
            pageCards = await fetchNativePage(root, nativePage);
          } catch (secondError) {
            console.error('[Daniello] image-safe pagination stopped:', secondError);
            break;
          }
        }
      }

      pageCards.forEach((card) => {
        const key = keyFor(card);
        if (!key || seen.has(key)) return;
        seen.add(key);
        cards.push(card);
      });

      if (cards.length >= needed) break;
      if (nativePage === nativePages) exhausted = true;
    }

    if (cards.length < needed) exhausted = true;

    return { cards, pageSize, nativePages, exhausted };
  };

  const updatePagination = (root, page, pageSize, cardCount, exhausted, nativePages) => {
    const pagination = root.querySelector('[data-image-safe-pagination]');
    if (!pagination) return;

    const hasPrevious = page > 1;
    const hasNext = cardCount > page * pageSize;
    const knownTotalPages = exhausted ? Math.max(1, Math.ceil(cardCount / pageSize)) : null;

    const prevGroup = pagination.querySelector('[data-pagination-prev-group]');
    const nextGroup = pagination.querySelector('[data-pagination-next-group]');
    const first = pagination.querySelector('[data-pagination-first]');
    const previous = pagination.querySelector('[data-pagination-previous]');
    const next = pagination.querySelector('[data-pagination-next]');
    const last = pagination.querySelector('[data-pagination-last]');
    const summary = pagination.querySelector('[data-pagination-summary]');

    if (first) first.href = virtualPageUrl(1);
    if (previous) previous.href = virtualPageUrl(Math.max(1, page - 1));
    if (next) next.href = virtualPageUrl(page + 1);
    if (last) {
      last.href = virtualPageUrl(knownTotalPages || nativePages);
      last.style.visibility = knownTotalPages ? '' : 'hidden';
      last.style.pointerEvents = knownTotalPages ? '' : 'none';
    }

    if (prevGroup) {
      prevGroup.classList.toggle('tw-opacity-0', !hasPrevious);
      prevGroup.classList.toggle('tw-opacity-100', hasPrevious);
      prevGroup.style.pointerEvents = hasPrevious ? '' : 'none';
    }

    if (nextGroup) {
      nextGroup.classList.toggle('tw-opacity-0', !hasNext);
      nextGroup.classList.toggle('tw-opacity-100', hasNext);
      nextGroup.style.pointerEvents = hasNext ? '' : 'none';
    }

    if (summary) {
      const template = pagination.dataset.pageLabel || 'Page %%PAGE%% of %%TOTAL%%';
      const totalLabel = knownTotalPages || nativePages;
      summary.textContent = template
        .replace('%%PAGE%%', String(page))
        .replace('%%TOTAL%%', String(totalLabel));
    }
  };

  const render = (root, result, requestedPage) => {
    const grid = root.querySelector('#product-grid');
    if (!grid || !result) return;

    const { cards, pageSize, nativePages, exhausted } = result;
    let page = requestedPage;
    let start = (page - 1) * pageSize;

    if (exhausted && start >= cards.length && cards.length > 0) {
      page = Math.max(1, Math.ceil(cards.length / pageSize));
      start = (page - 1) * pageSize;
      history.replaceState(history.state, '', virtualPageUrl(page));
    }

    const selected = cards.slice(start, start + pageSize);

    Array.from(grid.children).forEach((node) => {
      if (node.matches && node.matches('card-product')) node.remove();
    });

    grid.querySelectorAll('.hero-banner-column').forEach((banner) => {
      if (page !== 1) banner.remove();
    });

    selected.forEach((card) => grid.appendChild(card.cloneNode(true)));

    updatePagination(root, page, pageSize, cards.length, exhausted, nativePages);

    if (typeof ReloadSmartWishlist !== 'undefined' && typeof window.jQuery !== 'undefined' && jQuery.isFunction(ReloadSmartWishlist)) {
      ReloadSmartWishlist();
    }
  };

  const init = async () => {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root || root.dataset.imageSafeProcessing === 'true') return;

    root.dataset.imageSafeProcessing = 'true';
    root.setAttribute('aria-busy', 'true');
    root.querySelector('.collection')?.classList.add('loading');

    const token = ++generation;
    const requestedPage = currentVirtualPage();

    try {
      const result = await collectUntil(root, requestedPage, token);
      if (token !== generation || !result) return;
      render(root, result, requestedPage);
    } catch (error) {
      console.error('[Daniello] image-safe pagination:', error);
    } finally {
      if (token === generation) {
        root.dataset.imageSafeProcessing = 'false';
        root.removeAttribute('aria-busy');
        root.querySelector('.collection')?.classList.remove('loading');
      }
    }
  };

  const scheduleInit = () => {
    generation += 1;
    window.setTimeout(init, 30);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  window.addEventListener('page-update', scheduleInit);
})();
